module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('MentoringCardWrapper', {
    attrs: {
      "step": _vm.step,
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var ref_data = ref.data;
        var item = ref_data.item;
        var index = ref_data.index;
        var upperIndex = ref_data.upperIndex;

        return [_c('MentoringTeamCard', _vm._b({
          attrs: {
            "child": _vm.child,
            "index": upperIndex || index
          }
        }, 'MentoringTeamCard', item, false))]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01a09e48","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/teamslist/MentoringTeamsList.vue
// module id = a9d46c5a2a82b7dbce1e
// module chunks = 89